export type ChartDataStatus = {
    status: string;
    isEmpty: boolean | null;
};

export const chartsDataStatusMessageType = "superset-embedded:charts-data-status";

const settledWithoutDataStatuses = new Set(["failed", "stopped"]);

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === "object" && value !== null;

const isChartDataStatus = (value: unknown): value is ChartDataStatus =>
    isRecord(value) &&
    typeof value.status === "string" &&
    (value.isEmpty === null || typeof value.isEmpty === "boolean");

export const parseChartsDataStatusMessage = (data: unknown): Record<string, ChartDataStatus> | null => {
    if (!isRecord(data) || data.type !== chartsDataStatusMessageType || !isRecord(data.charts)) {
        return null;
    }

    const charts = Object.entries(data.charts);
    if (!charts.every(([, chart]) => isChartDataStatus(chart))) {
        return null;
    }

    return Object.fromEntries(charts) as Record<string, ChartDataStatus>;
};

const showsSomething = (chart: ChartDataStatus): boolean =>
    chart.isEmpty === false || (chart.isEmpty === null && settledWithoutDataStatuses.has(chart.status));

export const isDashboardEmpty = (statuses: Record<string, ChartDataStatus>): boolean | null => {
    const charts = Object.values(statuses);

    if (charts.some(showsSomething)) {
        return false;
    }

    if (charts.length === 0 || charts.some((chart) => chart.isEmpty !== true)) {
        return null;
    }

    return true;
};
